/**
 * getPlatform function return the the plateform.
 */
export function getPlatform(): 'NODE' | 'BROWSER' | 'JEST' {
	return typeof process === 'object'
		&& typeof process.versions === 'object'
		&& typeof process.versions.node !== 'undefined'
		? typeof window === 'object'
			? 'JEST' : 'NODE' : 'BROWSER';
}
